/** @format */

const VDO_COOKIE_SETTINGS = 'VDO_cookieSettings';
const GA_SWITCH_KEY = 'Google_Analytics_cookieSwitch';

function getCookie(name: string): string {
  const prefix = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const parts = decodedCookie.split(';');

  for (let i = 0; i < parts.length; i += 1) {
    let part = parts[i];
    while (part.charAt(0) === ' ') {
      part = part.substring(1);
    }
    if (part.indexOf(prefix) === 0) {
      return part.substring(prefix.length, part.length);
    }
  }

  return '';
}

/**
 * Parses Google_Analytics_cookieSwitch from VDO_cookieSettings cookie value.
 * Matches legacy format: {'Google_Analytics_cookieSwitch':true}
 *
 * @returns null when cookie value is missing or unparseable
 */
export function parseGoogleAnalyticsCookieSwitch(raw?: string | null): boolean | null {
  if (!raw) {
    return null;
  }

  try {
    const inner = raw.replace(/^\{|\}$/g, '').trim();
    const colonIndex = inner.indexOf(':');
    if (colonIndex === -1) {
      return null;
    }
    const valuePart = inner.slice(colonIndex + 1).trim();
    return JSON.parse(valuePart) === true;
  } catch {
    const match = raw.match(/Google_Analytics_cookieSwitch\s*['"]?\s*:\s*(true|false)/i);
    if (match) {
      return match[1].toLowerCase() === 'true';
    }
    return null;
  }
}

export function getAnalyticsConsent(): { granted: boolean; raw: string } {
  const raw = getCookie(VDO_COOKIE_SETTINGS);
  const parsed = parseGoogleAnalyticsCookieSwitch(raw);

  return {
    granted: parsed === true,
    raw
  };
}

/**
 * App-level GA dataLayer gate.
 * Blocks only when the legacy VDO cookie explicitly opts out.
 * Missing cookie stays allowed — staging/production use Consent Manager for script blocking,
 * and that CMP does not set `VDO_cookieSettings`.
 */
export function isAnalyticsConsentGranted(): boolean {
  const { raw } = getAnalyticsConsent();
  if (!raw) {
    return true;
  }

  return parseGoogleAnalyticsCookieSwitch(raw) !== false;
}

export { VDO_COOKIE_SETTINGS, GA_SWITCH_KEY };
